"use strict";
var AuthLevel, AuthLevel1;
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "AuthLevel", {
    enumerable: !0,
    get: function() {
        return AuthLevel;
    }
}), (AuthLevel1 = AuthLevel || (AuthLevel = {}))[AuthLevel1.RESTRICTED = 0] = "RESTRICTED", AuthLevel1[AuthLevel1.LOW = 1] = "LOW", AuthLevel1[AuthLevel1.STRONG = 2] = "STRONG";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9rZXlzdG9yZS9BdXRoTGV2ZWwudHMiXSwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBBdXRoZW50aWNhdGlvbiBsZXZlbC5cbiAqL1xuZXhwb3J0IGVudW0gQXV0aExldmVsIHtcbiAgICBSRVNUUklDVEVEID0gMCxcbiAgICBMT1cgPSAxLFxuICAgIFNUUk9ORyA9IDIsXG59XG4iXSwibmFtZXMiOlsiQXV0aExldmVsIl0sIm1hcHBpbmdzIjoiO2VBR1lBOzs7Ozs7OztLQUFBQSxhQUFBQSxjQUFBQSJ9